import './plugins/class-component-hooks';

// Quasar styles and icons
import 'quasar/dist/quasar.css';
import '@quasar/extras/material-icons/material-icons.css';

import '@/../node_modules/bootstrap/scss/bootstrap.scss';
import '@/../node_modules/vue-multiselect/dist/vue-multiselect.min.css';
import '@/assets/css/hococo.scss';
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';
import 'swiper/css/swiper.css';

import 'quill-emoji/dist/quill-emoji.css';

import './plugins/composition-api';
import './configuration/VeeValidateConfig';

import liveAgentButton from './plugins/live-agent-button';

import Vue from 'vue';
import vuexI18n from 'vuex-i18n';
import BootstrapTexts from '@/ts/BootstrapTexts';

import App from './App.vue';
import router from './router';
import store from './store';
import './registerServiceWorker';

import { UI } from '../tests/e2e/definitions';
import axios from 'axios';

import { Actions, Mutations } from '@/ts/store/Constants';
import { Connection } from '@/configuration/Connection';
import { englishLocaleConfig, danishLocaleConfig } from '@/configuration/momentConfig';
import VueCompositionApi from '@vue/composition-api';

// Filters
import filters from '@/filters';
Object.keys(filters).forEach((key) => { Vue.filter(key, (filters as any)[key]); });

import './quasar';

// @ts-ignore
const StripeSDK = require('./stripeSource.js');
StripeSDK.loadStripeSdk();

import QGrid from '@/../quasar-extensions/qgrid/app-extension/src/components/QGrid.vue';

Vue.component('QGrid', QGrid);
Vue.component('q-grid', QGrid);


Vue.use(VueCompositionApi);

Vue.use(liveAgentButton);

import VCalendar from 'v-calendar';
Vue.use(VCalendar, {
    componentPrefix: 'vc',
});

// Internationalization
Vue.use(vuexI18n.plugin, store, {
    moduleName: 'i18n',
    onTranslationNotFound: (locale: string, key: string, defaultValue: string) => {
        store.dispatch(Actions.FLAG_MISSING_TRANSLATION, {
            key,
            defaultValue,
        });
    },
});

Vue.i18n.add('en', BootstrapTexts);
Vue.i18n.set('en');

// Vee-validate
import VeeValidate from 'vee-validate';
Vue.use(VeeValidate);

// vue-line-clamp
import lineClamp from 'vue-line-clamp';
Vue.use(lineClamp, {
    importCss: true,
});

// Vue touch events
import Vue2TouchEvents from 'vue2-touch-events';
Vue.use(Vue2TouchEvents);

import { VueHammer } from 'vue2-hammer';
Vue.use(VueHammer);

// Friendly async iFrame
import VueFriendlyIframe from 'vue-friendly-iframe';
Vue.component('vue-friendly-iframe', VueFriendlyIframe);

// Moment (localized date handling)
import moment from 'moment-timezone';
moment.defineLocale('en', {
    parentLocale: 'en',
    englishLocaleConfig,
});
moment.defineLocale('da', {
    parentLocale: 'da',
    danishLocaleConfig,
});
moment.locale('en', englishLocaleConfig);
moment.locale('da', danishLocaleConfig);
moment.tz.setDefault('Europe/Copenhagen');
import VueMoment from 'vue-moment';
Vue.use(VueMoment, {moment});

// VueWebCam
import WebCam from 'vue-web-cam';
Vue.use(WebCam);

import Zendesk from '@dansmaculotte/vue-zendesk';

// Vue.use(Zendesk, {
//   key: '592fb61f-a991-4472-bfd0-3a1cee26ba23',
//   disabled: false,
//   hideOnLoad: true,
//   settings: {
//         webWidget: {
//             offset: { horizontal: '25px', vertical: '60px' },
//             position: { horizontal: 'left', vertical: 'bottom' },
//             color: {
//                 theme: '#24514a',
//             },
//         },
//     },
// });

// Laravel Echo
import SocketIO from 'socket.io-client';
import VueEcho from 'vue-echo';

if (Connection.socketEnabled) {
    window.io = SocketIO;

    Vue.use(VueEcho, {
        broadcaster: 'socket.io',
        host: Connection.getEchoUrl(),
    });
}

// Vue type augmentations
import './vue-augmentations';

import Loading from './plugins/Loading';
const loadingHelper = new Loading();

// Disable tips in production
Vue.config.productionTip = false;

// Enable devtools
Vue.config.devtools = true;

// Enable performance analysis
// Vue.config.performance = process.env.NODE_ENV !== 'production';
Vue.config.performance = false;

import { LoadingBar } from 'quasar';

axios.interceptors.request.use((request) => {
    const CancelToken = axios.CancelToken;
    const source      = CancelToken.source();
    const token       = source.token;

    request.cancelToken = token;
    store.commit(Mutations.TOGGLE_CANCELLATION_TOKEN, { url: request.url, cancelToken: token, source });

    if (
        !loadingHelper.checkIfRouteIsBlacklisted(request.url) &&
        !store.state.Loading.loadingStatus &&
        !store.state.Loading.loadingLock
    ) {
        loadingHelper.checkIfRequireLoadingBar(request.url)
            ? LoadingBar.start(500)
            : store.commit(Mutations.SET_LOADING_STATUS, true);
    }

    if (Connection.clockwork === true) {
        if (!request.params) {
            request.params = {
                'clockwork-profile': Connection.clockworkSecret,
            };
        }

        if (request.params && !request.params.hasOwnProperty('clockwork-profile')) {
            request.params['clockwork-profile'] = Connection.clockworkSecret;
        }
    }

    if (['put', 'patch', 'delete'].includes(request.method)) {
        request.headers['X-HTTP-Method-Override'] = request.method.toUpperCase();

        if (request.data && !request.data.hasOwnProperty('_method')) {
            request.data._method = request.method.toUpperCase();
        }

        request.method = 'POST';
    }

    return request;
});

axios.interceptors.response.use((response) => {
    if (!loadingHelper.checkIfRouteIsBlacklisted(response.request.responseURL)) {
        loadingHelper.checkIfRequireLoadingBar(response.request.responseURL)
            ? LoadingBar.stop()
            : setTimeout(() => { store.commit(Mutations.SET_LOADING_STATUS, false); }, 500);
    }

    store.commit(Mutations.TOGGLE_CANCELLATION_TOKEN, { url: response.request.responseURL });
    return response;

}, (error) => {
    LoadingBar.stop();
    store.commit(Mutations.SET_LOADING_STATUS, false);

    if (!axios.isCancel(error) && error.response) {
        store.commit(Mutations.TOGGLE_CANCELLATION_TOKEN, { url: error.response.request.responseURL });
    }

    if (error.response && error.response.status === 401) {
        store.dispatch(Actions.LOG_OUT);
    }

    return Promise.reject(error);
});

Vue.prototype.$UI = UI;

const vue = new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');




